export default {
  TITLE: 'Occupation Comparison',
  SUBTITLE: 'Explore and compare roles by skill compatibility, job demand, and more.',
  COMPARE_BY: 'Compare by',
  SKILL_MATCH: 'Skill Match',
  GROWTH: 'Growth',
  GROWTH_LAST_7_DAYS: 'Growth: last 7 days',
  SALARY: 'Salary',
  AI_IMPACT: 'AI Impact',
  OCCUPATION_DEMAND: 'Occupation Demand',
  AI_IMPACT_LEVEL_1: 'Low',
  AI_IMPACT_LEVEL_2: 'Very Low',
  AI_IMPACT_LEVEL_3: 'Moderate',
  AI_IMPACT_LEVEL_4: 'High',
  AI_IMPACT_LEVEL_5: 'Very High',
  METRIC_SKILL_MATCH: '{{value}}% skill match',
  METRIC_GROWTH: '+{{value}}% growth',
  METRIC_SALARY_PER_YEAR: '{{value}}K per year',
  METRIC_OCCUPATION_DEMAND: '{{count}} postings',
  DEMAND_LEVEL_1: 'Niche demand',
  DEMAND_LEVEL_2: 'Moderate demand',
  DEMAND_LEVEL_3: 'Established demand',
  DEMAND_LEVEL_4: 'High demand',
  DEMAND_LEVEL_5: 'Mass market demand',
  METRIC_DEMAND_LEVEL_FALLBACK: 'Demand level {{value}}',
  METRIC_AI_LEVEL_FALLBACK: 'Level {{value}}',
  QUICK_COMPARISON: 'Quick Occupation Comparison',
  EXIT_COMPARISON: 'Exit Comparison',
  NO_DATA: 'No data',
  NO_DATA_DESCRIPTION: 'This information is not yet available for the selected occupations.',
  NO_DATA_FOR_OCCUPATION: 'No data available for this occupation',
  ERROR_TITLE: 'Comparison data unavailable',
  ERROR_DESCRIPTION: 'We could not load all comparison metrics. Please try again later.',
  SELECT_MORE_OCCUPATIONS: 'Select more occupations in order to compare them side by side.',
  LOADING: 'Loading occupation comparison',
  SELECT_OCCUPATION: 'Select {{occupation}} to compare',
  CHART_ARIA_LABEL: 'Occupation comparison chart',
  SELECTED_FILTER: '{{filter}} selected',
};
